module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [(this.useAnatel) ? _c('form-group', {
    attrs: {
      "label": "Identificador de certificação da Anatel",
      "columns": 3,
      "required": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.identifierAnatel),
      expression: "identifierAnatel"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.identifierAnatel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.identifierAnatel = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('warranty.label'),
      "error": _vm.getError('warranty', _vm.product.productId),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.warrantyTime),
      expression: "product.warrantyTime"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.warrantyTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "warrantyTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), (this.attributes.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])]) : _vm._e(), _vm._v(" "), _vm._l((this.attributes), function(attribute) {
    return (attribute.name !== 'weight' && attribute.name !== 'color' && attribute.name !== 'quantity') ? _c('form-group', {
      attrs: {
        "label": _vm.$t(attribute.name + '.label')
      }
    }, [((attribute.type) === 'checkbox' && (attribute.type !== 'decimal' && attribute.type !== 'select')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.name]),
        expression: "product.attributes[attribute.name]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.product.attributes[attribute.name]) ? _vm._i(_vm.product.attributes[attribute.name], null) > -1 : (_vm.product.attributes[attribute.name])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.product.attributes[attribute.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.product.attributes, attribute.name, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.product.attributes, attribute.name, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.product.attributes, attribute.name, $$c)
          }
        }
      }
    }) : ((attribute.type) === 'radio' && (attribute.type !== 'decimal' && attribute.type !== 'select')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.name]),
        expression: "product.attributes[attribute.name]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.product.attributes[attribute.name], null)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.product.attributes, attribute.name, null)
        }
      }
    }) : (attribute.type !== 'decimal' && attribute.type !== 'select') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.name]),
        expression: "product.attributes[attribute.name]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": attribute.type
      },
      domProps: {
        "value": (_vm.product.attributes[attribute.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.product.attributes, attribute.name, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (attribute.type === 'decimal') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.name]),
        expression: "product.attributes[attribute.name]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "number",
        "step": ".1"
      },
      domProps: {
        "value": (_vm.product.attributes[attribute.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.product.attributes, attribute.name, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (attribute.type === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.name]),
        expression: "product.attributes[attribute.name]"
      }],
      staticClass: "form-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.product.attributes, attribute.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((attribute.values), function(value) {
      return (attribute.values !== undefined) ? _c('option', {
        key: value.id,
        domProps: {
          "value": value.name
        }
      }, [_vm._v("\n          " + _vm._s(value.name) + "\n        ")]) : _vm._e()
    })], 2) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Ficha Técnica")])])]), _vm._v(" "), _vm._l((this.technicalAttributes), function(technicalAttribute) {
    return _c('div', {
      staticClass: "l-col-12@md no-padding"
    }, [_c('form-group', {
      attrs: {
        "label": "Nome do atributo"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (technicalAttribute['name']),
        expression: "technicalAttribute['name']"
      }],
      staticClass: "col form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (technicalAttribute['name'])
      },
      on: {
        "change": _vm.isFormValid,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(technicalAttribute, 'name', $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('form-group', {
      attrs: {
        "label": "Valor"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (technicalAttribute['value']),
        expression: "technicalAttribute['value']"
      }],
      staticClass: "col form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (technicalAttribute['value'])
      },
      on: {
        "change": _vm.isFormValid,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(technicalAttribute, 'value', $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.removeTechnicalSpec(technicalAttribute['id'])
        }
      }
    }, [_vm._v("Remover")])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md no-padding"
  }, [_c('button', {
    staticClass: "btn btn--smart btn--sm btn--info l-level__right",
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "disabled": !this.isFormValid()
    },
    on: {
      "click": _vm.addTechnicalSpec
    }
  }, [_vm._v("Adicionar Atributo")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ffd7777","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/integracommerce/provide/Product.vue
// module id = 3280
// module chunks = 0